var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "window",
      attrs: {
        id: "chat-container",
        "data-current-channel": _vm.channel.name,
        lang: "",
      },
    },
    [
      _c(
        "div",
        {
          class: {
            "hide-motd": !_vm.$store.state.settings.motd,
            "colored-nicks": _vm.$store.state.settings.coloredNicks,
            "time-seconds": _vm.$store.state.settings.showSeconds,
            "time-12h": _vm.$store.state.settings.use12hClock,
          },
          attrs: { id: "chat" },
        },
        [
          _c(
            "div",
            {
              staticClass: "chat-view",
              attrs: {
                id: "chan-" + _vm.channel.id,
                "data-type": _vm.channel.type,
                "aria-label": _vm.channel.name,
                role: "tabpanel",
              },
            },
            [
              _c(
                "div",
                { staticClass: "header" },
                [
                  _c("SidebarToggle"),
                  _c(
                    "span",
                    {
                      staticClass: "title",
                      attrs: {
                        "aria-label": "Currently open " + _vm.channel.type,
                      },
                    },
                    [_vm._v(_vm._s(_vm.channel.name))]
                  ),
                  _vm.channel.editTopic === true
                    ? _c("div", { staticClass: "topic-container" }, [
                        _c("input", {
                          ref: "topicInput",
                          staticClass: "topic-input",
                          attrs: {
                            placeholder: "Set channel topic",
                            enterkeyhint: "done",
                          },
                          domProps: { value: _vm.channel.topic },
                          on: {
                            keyup: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.saveTopic.apply(null, arguments)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "esc",
                                    27,
                                    $event.key,
                                    ["Esc", "Escape"]
                                  )
                                ) {
                                  return null
                                }
                                _vm.channel.editTopic = false
                              },
                            ],
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "save-topic",
                            attrs: { "aria-label": "Save topic" },
                            on: { click: _vm.saveTopic },
                          },
                          [
                            _c("span", {
                              attrs: {
                                type: "button",
                                "aria-label": "Save topic",
                              },
                            }),
                          ]
                        ),
                      ])
                    : _c(
                        "span",
                        {
                          class: { topic: true, empty: !_vm.channel.topic },
                          attrs: { title: _vm.channel.topic },
                          on: { dblclick: _vm.editTopic },
                        },
                        [
                          _vm.channel.topic
                            ? _c("ParsedMessage", {
                                attrs: {
                                  network: _vm.network,
                                  text: _vm.channel.topic,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                  _vm.$store.state.settings.searchEnabled &&
                  ["channel", "query"].includes(_vm.channel.type)
                    ? _c("MessageSearchForm", {
                        attrs: { network: _vm.network, channel: _vm.channel },
                      })
                    : _vm._e(),
                  _c("button", {
                    staticClass: "mentions",
                    attrs: { "aria-label": "Ju ka permend dikush!" },
                    on: { click: _vm.openMentions },
                  }),
                  _c("button", {
                    staticClass: "menu",
                    attrs: { "aria-label": "Open the context menu" },
                    on: { click: _vm.openContextMenu },
                  }),
                  _vm.channel.type === "channel"
                    ? _c(
                        "span",
                        {
                          staticClass: "rt-tooltip tooltipped tooltipped-w",
                          attrs: { "aria-label": "Lista e Vizitoreve" },
                        },
                        [
                          _c("button", {
                            staticClass: "rt",
                            attrs: { "aria-label": "Toggle user list" },
                            on: {
                              click: function ($event) {
                                return _vm.$store.commit("toggleUserlist")
                              },
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.channel.type === "special"
                ? _c("div", { staticClass: "chat-content" }, [
                    _c("div", { staticClass: "chat" }, [
                      _c("div", { staticClass: "messages" }, [
                        _c(
                          "div",
                          { staticClass: "msg" },
                          [
                            _c(_vm.specialComponent, {
                              tag: "component",
                              attrs: {
                                network: _vm.network,
                                channel: _vm.channel,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ])
                : _c(
                    "div",
                    { staticClass: "chat-content" },
                    [
                      _c(
                        "div",
                        {
                          class: [
                            "scroll-down tooltipped tooltipped-w tooltipped-no-touch",
                            {
                              "scroll-down-shown":
                                !_vm.channel.scrolledToBottom,
                            },
                          ],
                          attrs: { "aria-label": "Jump to recent messages" },
                          on: {
                            click: function ($event) {
                              return _vm.$refs.messageList.jumpToBottom()
                            },
                          },
                        },
                        [_c("div", { staticClass: "scroll-down-arrow" })]
                      ),
                      _vm.channel.type === "channel"
                        ? _c("ChatUserList", {
                            attrs: { channel: _vm.channel },
                          })
                        : _vm._e(),
                      _c("MessageList", {
                        ref: "messageList",
                        attrs: {
                          network: _vm.network,
                          channel: _vm.channel,
                          focused: _vm.focused,
                        },
                      }),
                    ],
                    1
                  ),
            ]
          ),
        ]
      ),
      _vm.$store.state.currentUserVisibleError
        ? _c(
            "div",
            {
              attrs: { id: "user-visible-error" },
              on: { click: _vm.hideUserVisibleError },
            },
            [
              _vm._v(
                "\n\t\t" +
                  _vm._s(_vm.$store.state.currentUserVisibleError) +
                  "\n\t"
              ),
            ]
          )
        : _vm._e(),
      _c("ChatInput", {
        attrs: { network: _vm.network, channel: _vm.channel },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }